import React from "react"
import { useState, useEffect } from "react"
import tw from "twin.macro"
import ModalService from "./ModalService"
import { resetScroll, useWindowSize } from "../../utils"

const ModalRoot = () => {
  const [modal, setModal] = useState({})

  useEffect(() => {
    ModalService.on("open", ({ component, props }) => {
      setModal({
        component,
        props,
        close: value => {
          setModal({})
          resetScroll()
        },
      })
    })
    ModalService.on("closeModal", ({ component, props }) => {
      if (component === "SavingsCardModal") {
        sessionStorage.setItem("savings-card-modal", "closed")
      }
      setModal({})
      resetScroll()
    })
  }, [])

  const ModalComponent = modal.component ? modal.component : null
  const { height } = useWindowSize()

  return (
    <div
      className="modalContainer"
      css={[tw`absolute w-full z-50 hidden`, `height: ${height}px`]}
      style={modal.component ? { display: "flex" } : {}}
    >
      {ModalComponent && (
        <ModalComponent
          {...modal.props}
          close={modal.close}
          className={ModalComponent ? "modal" : ""}
        />
      )}
    </div>
  )
}

export default ModalRoot
